import { boolean, object, ObjectSchema } from 'yup';
import { REQUIRED_PHONE_NUMBER_VALIDATOR, REQUIRED_VALIDATION_MESSAGE } from '@/helpers/formHelpers/validators';

export type CompleteRegistrationValidationSchemaType = {
  mobile_phone: string;
  confirmed_phone_number: boolean;
  confirmed_reset_password: boolean;
};

export const ADMIN_COMPLETE_REGISTRATION_VALIDATION_SCHEMA: ObjectSchema<CompleteRegistrationValidationSchemaType> =
  object().shape({
    mobile_phone: REQUIRED_PHONE_NUMBER_VALIDATOR,
    confirmed_phone_number: boolean().oneOf([true], REQUIRED_VALIDATION_MESSAGE).required(REQUIRED_VALIDATION_MESSAGE),
    confirmed_reset_password: boolean()
      .oneOf([true], REQUIRED_VALIDATION_MESSAGE)
      .required(REQUIRED_VALIDATION_MESSAGE),
  });
